import React from "react";
import Navbar from "../components/navbar";
export default function PageNotFound(){
    return(<><Navbar /><div ><h4>404 |This page is not found.</h4></div></>)
}